module.exports = __webpack_public_path__ + "static/media/apple-1841553_1920.41f8a9a2.jpg";